import CmsBlock from "@/helpers/editor/blocks/CmsBlock.js";
import CmsComponentImage from "@/helpers/editor/components/CmsComponentImage.js";

export default class CmsBlockMap extends CmsBlock {
    static typeDef = {
        name: `Wayfinding Map|Plan navigation`,
        glyph: `fas fa-map`,
        type: `map`,
        category: `widget`,
        isParent: false
    }

    constructor(data, page) {
        super(data, page);

        this.padding.init(0);

        this.bannerImage = new CmsComponentImage(this.bannerImage);
    }
}
